module.exports = __webpack_public_path__ + "static/media/1006193.e67ae128.png";